export const iconFontAwesomeFoodBeverageFish = (
	<i className="fa-solid fa-fish"></i>
);
